import script from "./CheckinsAlerts.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckinsAlerts.vue?vue&type=script&setup=true&lang=js"

import "./CheckinsAlerts.vue?vue&type=style&index=0&id=3d343fcd&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d343fcd"]])

export default __exports__